import React from 'react';
import {MenuItem, Pagination, Select, Stack} from '@mui/material';
import {SelectChangeEvent} from '@mui/material/Select';
import {BasicPage} from '../../../@types/spring-data-page';
import {WorkspaceResource} from '../../../@types/workspace-types';

interface ExplorerPaginationProps {
    page: BasicPage;
    objects: WorkspaceResource | null;
    pageSizes: number[];
    uuidRef: string;
    onPageSizeChange: (event: SelectChangeEvent<number>) => void;
    onPageChange: (event: React.ChangeEvent<unknown>, pageNumber: number) => void;
}

/**
 * Pagination controls for the Explorer component
 */
export const ExplorerPagination: React.FC<ExplorerPaginationProps> = ({
    page,
    objects,
    pageSizes,
    uuidRef,
    onPageSizeChange,
    onPageChange
}) => {
    return (
        <Stack direction={'row'} spacing={0} sx={{ alignSelf: 'center', marginTop: 'auto' }}>
            <Select
                variant='standard'
                role='presentation'
                labelId={`select-label-${uuidRef}`}
                id={`select-${uuidRef}`}
                value={page.size}
                onChange={onPageSizeChange}
                sx={{ fontSize: '14px' }}
            >
                {pageSizes.map(size => (
                    <MenuItem key={size} value={size}>{size} per page</MenuItem>
                ))}
            </Select>
            {objects && objects.page && objects.resources && (
                <Pagination 
                    count={objects.page.totalPages} 
                    size={'small'} 
                    style={{ paddingTop: '2px', fontSize: '13px' }} 
                    showFirstButton 
                    showLastButton
                    page={page?.offset ? page.offset + 1 : 1} 
                    siblingCount={0} 
                    boundaryCount={1} 
                    onChange={onPageChange}
                />
            )}
        </Stack>
    );
};